'use client'
import {useEffect, useState} from 'react'

export const MAX_MOBILE_WIDTH = 960

export function useIsOnMobile(maxMobileWidth = MAX_MOBILE_WIDTH) {
  const [isOnMobile, setIsOnMobile] = useState(false)

  const recalculateIsOnMobile = () => {
    if (window.outerWidth < maxMobileWidth) {
      setIsOnMobile(true)
    } else {
      setIsOnMobile(false)
    }
  }

  useEffect(() => {
    recalculateIsOnMobile()
    window.addEventListener('resize', recalculateIsOnMobile)

    return () => {
      window.removeEventListener('resize', recalculateIsOnMobile)
    }
  }, [])

  return isOnMobile
}
